import '@/installCompositionApi'

import { mountComponentTag } from '@/mounter'

import DotcomAppScreens from './AppScreens'

mountComponentTag('app-screens', DotcomAppScreens)
